import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BrandMark from "@/components/feature/BrandMark";
import Button from "@/components/base/Button";
import { navLinks, site } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (href: string) =>
    href === "/" ? location.pathname === "/" : location.pathname.startsWith(href);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur-md"
          : "border-b border-transparent bg-background-50/70 backdrop-blur-sm"
      }`}
    >
      <div className="shell flex h-16 items-center justify-between gap-4 md:h-20">
        <Link to="/" aria-label={`${site.name} anasayfa`} className="cursor-pointer">
          <BrandMark />
        </Link>

        <nav className="hidden items-center gap-0.5 xl:flex" aria-label="Birincil menü">
          {navLinks.map((link) => {
            const active = isActive(link.href);
            return (
              <Link
                key={link.href}
                to={link.href}
                aria-current={active ? "page" : undefined}
                className={`cursor-pointer whitespace-nowrap rounded-md px-2.5 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-background-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <Button
            href={site.whatsapp}
            external
            variant="primary"
            icon="ri-whatsapp-line"
            className="hidden sm:inline-flex"
          >
            WhatsApp'tan Randevu
          </Button>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Menüyü aç/kapat"
            aria-expanded={menuOpen}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:border-primary-400 xl:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 xl:hidden">
          <nav className="shell flex flex-col py-3" aria-label="Mobil menü">
            {navLinks.map((link) => {
              const active = isActive(link.href);
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setMenuOpen(false)}
                  aria-current={active ? "page" : undefined}
                  className={`cursor-pointer rounded-md px-3 py-3 text-base font-medium transition-colors ${
                    active
                      ? "bg-background-100 text-primary-700"
                      : "text-foreground-800 hover:bg-background-100 hover:text-primary-700"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="mt-3 flex flex-col gap-2 px-3 pb-3 sm:hidden">
              <Button href={site.whatsapp} external variant="primary" icon="ri-whatsapp-line">
                WhatsApp'tan Randevu
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}